import Vue from "vue";
import Vuex from "vuex";


Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		api_url: process.env.VUE_APP_API_URL,
		categories: [],
		category_exists: 0,
		category_slug: null,
		layout: {
			card_class: 'row-cols-1 row-cols-md-2',
			logo: 'https://media.iamconnected.com/images/iac_oc_logo-gold.png',
		},
		menu: null,
		profile: {
			status: 0,
		},
		search_term: null,
		session_id: null,
		show_loading: 1,
		year: null,

	},
	mutations: {
		categoryActiveSet(state, data){
			console.log('categoryActiveSet:' + data);
			var result = 0;
			
			if(data === 'latest'){
				state.category_slug = null;
				state.category_exists = 1;
				return true;
			}
			else
			{
				if(typeof this.getters.categoriesGet !== 'undefined'){
					result = this.getters.categoriesGet.filter(function(e) {
						if(e.slug == data){
							return 1;
						}
					});
				}
			}

			state.category_exists = result.length;
		},
		
		categoriesSet(state, data){
			state.categories = Object.values(data);
		},
		categorySlugSet(state, slug){
			state.category_slug = slug;
		},
		menuSet(state, data){
			state.menu = data.menu;
		},
		profileSet(state, data){
			state.profile = data.profile;
			state.session_id = data.profile.session_id;
			data.profile.is_admin = (data.profile.level >= 90) ? 1 : 0;
		},
		searchTermSet(state, data){
			state.search_term = data.search_term;
		},
	},
	computed: {
	},
	actions: {
	},
	modules: {
	},
	getters: {

		categoriesGet: state => {
			return state.categories;
		},
		categoryActiveGet: state => {
			var result = null;
			var category = null;
			if(state.categories !== 'undefined' && state.categories.length > 0){
				result = state.categories.filter(function(e) {
					if(e.slug == state.category_slug){
						return 1;
					}
				});
			}
			
			if(state.category_slug === null){
				category = null;
			}
			else if(result !== null && result[0]){
				category = result[0];
			}
			
			return category;
		},
		
		menuGet: state => {
			return state.menu;
		},
		profileGet: state => {
			return state.profile;
		},
		profileGetName: state => {
			if(state.profile.first_name !== null){
				return state.profile.user_name;
			}
			else{
				return state.profile.first_name;
			}
		},
		profileUserName: state => {
			return state.profile.user_name;
		},
		searchTermGet: state => {
			return state.search_term;
		},
	},
	watch: {
		search_term: function(val){
			console.log(val);
		},
	}
});

export default store;